// Created by Johan Schram - KOSMEO ANALYTICS - https://kosmeo-a.com on 16/05/2017.

var React = require('react');
var CreateReactClass = require('create-react-class');
var PropTypes = require('prop-types');

import './adress-selection.component.css';

import restService from '../../services/rest-service';

import metro from '../../img/metro_ico.png'

var windowHeight = 0;

var styles = {
    adressSelectionWraper : {
        width : '100%',
        position : 'absolute',
        paddingTop: 0,
        top : 0,
        right : 0,
        zIndex: 10,
        overflow: 'hidden',
        boxSizing: 'border-box',
        height:  'calc(100vh - 50px)'
    },
    adressSelectionInput : {
        width : '100%',
        paddingBottom : 10,
        paddingTop : 10
    },
    adressSelectionList : {
        width : '100%',
        height: 'calc((100vh - 50px) - 134px)',
        position:'absolute',
        transition: 'top 250ms ease-out',
        overflowY: 'scroll'
    },
    adressSelectionListUL : {
        paddingBottom: 'calc((100vh - 50px) - 134px - 37px)'
    }
};


var iconesStations = {
    metro :  {ico: require("../../img/stations/Metro-M.svg.png"), type : 'metro', order : 0},
    train :  {ico: require("../../img/stations/Logo_train_transilien.svg.png"), type : 'metro', order : 0},
    rer :  {ico: require("../../img/stations/RER.svg.png"), type : 'metro', order : 0},
    tram :  {ico: require("../../img/stations/Tramway-T.svg.png"), type : 'metro', order : 0},
    "M1": {ico: require("../../img/stations/Paris_m_1_jms.svg.png"), type : 'metro', order : 1},
    "M2": {ico: require("../../img/stations/Paris_m_2_jms.svg.png"), type : 'metro', order : 2},
    "M3": {ico: require("../../img/stations/Paris_m_3_jms.svg.png"), type :'metro', order : 3},
    "M3b": {ico: require("../../img/stations/Paris_m_3bis_jms.svg.png"), type : 'metro', order : 4},
    "M4": {ico: require("../../img/stations/Paris_m_4_jms.svg.png"), type : 'metro', order : 5},
    "M5": {ico: require("../../img/stations/Paris_m_5_jms.svg.png"), type : 'metro', order : 6},
    "M6":{ico: require("../../img/stations/Paris_m_6_jms.svg.png"), type : 'metro', order : 7},
    "M7": {ico: require("../../img/stations/Paris_m_7_jms.svg.png"), type : 'metro', order : 8},
    "M7b": {ico: require("../../img/stations/Paris_m_7bis_jms.svg.png"), type : 'metro', order : 9},
    "M8": {ico: require("../../img/stations/Paris_m_8_jms.svg.png"), type : 'metro', order : 10},
    "M9": {ico: require("../../img/stations/Paris_m_9_jms.svg.png"), type : 'metro', order : 11},
    "M10": {ico: require("../../img/stations/Paris_m_10_jms.svg.png"), type : 'metro', order : 12},
    "M11": {ico: require("../../img/stations/Paris_m_11_jms.svg.png"), type : 'metro', order : 13},
    "M12": {ico: require("../../img/stations/Paris_m_12_jms.svg.png"), type : 'metro', order : 14},
    "M13": {ico: require("../../img/stations/Paris_m_13_jms.svg.png"), type : 'metro', order : 15},
    "M14": {ico: require("../../img/stations/Paris_m_14_jms.svg.png"), type :'metro', order : 16},
    "T1": {ico: require("../../img/stations/Logo_Paris_tram_ligne1.svg.png"), type : 'tram' , order : 17},
    "T2": {ico: require("../../img/stations/Logo_Paris_tram_ligne2.svg.png"), type : 'tram' , order : 18},
    "T3A": {ico: require("../../img/stations/Logo_Paris_tram_ligne3a.svg.png"), type : 'tram' , order : 19},
    "T3B": {ico: require("../../img/stations/Logo_Paris_tram_ligne3b.svg.png"), type : 'tram' , order : 20},
    "T4": {ico: require("../../img/stations/Logo_Paris_tram_ligne4.svg.png"), type : 'tram' , order : 21},
    "T5": {ico: require("../../img/stations/Logo_Paris_tram_ligne5.svg.png"), type : 'tram' , order : 22},
    "T6": {ico: require("../../img/stations/Logo_Paris_tram_ligne6.svg.png"), type : 'tram' , order : 23},
    "T7": {ico: require("../../img/stations/Logo_Paris_tram_ligne7.svg.png"), type : 'tram' , order :24},
    "T8": {ico: require("../../img/stations/Logo_Paris_tram_ligne8.svg.png"), type : 'tram' , order : 25},
    "RER A": {ico: require("../../img/stations/Paris_RER_A_icon.svg.png"), type : 'rer' , order : 26},
    "RER B": {ico: require("../../img/stations/Paris_RER_B_icon.svg.png"), type : 'rer' , order : 27},
    "RER C": {ico: require("../../img/stations/Paris_RER_C_icon.svg.png"), type : 'rer' , order : 28},
    "RER D": {ico: require("../../img/stations/Paris_RER_D_icon.svg.png"), type : 'rer' , order : 29},
    "RER E": {ico: require("../../img/stations/Paris_RER_E_icon.svg.png"), type : 'rer' , order : 30},
    "LIGNE H": {ico: require("../../img/stations/Logo_Paris_Transilien_ligneH.svg.png"), type : 'train' , order : 31},
    "LIGNE J": {ico: require("../../img/stations/Logo_Paris_Transilien_ligneJ.svg.png"), type : 'train' , order : 32},
    "LIGNE K": {ico: require("../../img/stations/Logo_Paris_Transilien_ligneK.svg.png"), type : 'train' , order : 33},
    "LIGNE L": {ico: require("../../img/stations/Logo_Paris_Transilien_ligneL.svg.png"), type : 'train' , order : 34},
    "LIGNE N": {ico: require("../../img/stations/Logo_Paris_Transilien_ligneN.svg.png"), type : 'train' , order : 35},
    "LIGNE P": {ico: require("../../img/stations/Logo_Paris_Transilien_ligneP.svg.png"), type : 'train' , order : 36},
    "LIGNE R": {ico: require("../../img/stations/Logo_Paris_Transilien_ligneR.svg.png"), type : 'train' , order : 37},
    "LIGNE U": {ico: require("../../img/stations/Logo_Paris_Transilien_ligneU.svg.png"), type : 'train' , order : 38}
};

var closing = false;

var AdressSelectionInput = CreateReactClass({
    propTypes : {
        handleAdressChange : PropTypes.func,
        onClickBack: PropTypes.func,
        topPosition : PropTypes.object,
        adressInput :  PropTypes.string,
        clear : PropTypes.func,
        waitingForBan : PropTypes.bool,
        onClickSelectOnMap : PropTypes.func
    },
    defaultProps : {},
    componentDidMount() {
        document.getElementById("inputForAdress").focus();
    },
    render: function () {

        return (
            <div style={{ ...styles.adressSelectionInput, ...this.props.topPosition}} className="adressSelectionInput">
                <div className="ligneFlexStartCentered" style={{color: 'white', paddingLeft: 10, paddingRight: 10, paddingBottom: 0}}>
                    <div  onClick={this.props.onClickBack}>
                        <span className="fa fa-arrow-left fa-2x"></span>
                    </div>
                    <div  style={{paddingLeft: 10, paddingRight: 20, fontWeight: 700, flex : 1, textAlign: 'center'}}>
                        Saisir une adresse
                    </div>
                </div>
                <div className="inputWraper0 ligneFlexCenteredCentered">
                    <div className="inputWraper ligneFlexStartCentered">
                        <input id='inputForAdress' placeholder="Adresse" value={this.props.adressInput} onChange={this.props.handleAdressChange} />

                        {(this.props.waitingForBan) ?  (
                            <div>
                                <span className="fa fa-spinner fa-pulse fa-2x fa-fw"></span>
                            </div>
                        ) : false
                        }

                        {(this.props.adressInput) ?  (
                            <div onClick={this.props.clear}>
                                <span className="fa fa-times fa-2x" ></span>
                            </div>
                        ) : (<div style={{height : 28}}></div>)
                        }

                    </div>
                </div>
                <div className="ligneFlexStartCentered" onClick={this.props.onClickSelectOnMap} style={{color: 'white', paddingLeft: 10, paddingRight: 10}}>
                    <span className="fa fa-map-marker fa-2x" ></span>
                    <div  style={{paddingLeft: 10, fontWeight: 700}}>
                        Choisir un point sur la carte
                    </div>
                </div>
            </div>
        )
    }
});

var AdressSelectionList = CreateReactClass({
    propTypes : {
        adressList:  PropTypes.array,
        selectAdress :  PropTypes.func,
        topPosition : PropTypes.object
    },
    defaultProps : {
        adressList: [],
    },
    render: function () {

        var renderIconeStation = function(lines){

            var linesModif = [];
            for (var i = 0 ; i < lines.length; i++){
                linesModif.push({
                    lib : lines[i],
                    type : iconesStations[lines[i]].type,
                    order : iconesStations[lines[i]].order
                })
            }

            linesModif.sort(function(a, b) {
                return a.order - b.order;
            });

            linesModif.splice(0,0, {
                lib : linesModif[0].type,
                type : "splicer",
            });


            for (i = 1 ; i < linesModif.length; i++){
                if (linesModif[i].type !== linesModif[i-1].type && linesModif[i-1].type !== "splicer") {
                    linesModif.splice(i,0, {
                        lib : linesModif[i].type,
                        type : "splicer",
                    });
                }
            }

            return linesModif.map(function(item, index){
                if (item.type === "splicer"){
                    return <div key={index} style={{paddingLeft: 20, paddingRight: 2, height: 16}}><img src={iconesStations[item.lib].ico} /></div>
                }
                else {
                    return <div key={index} style={{paddingLeft: 2, paddingRight: 2, height: 16}}><img src={iconesStations[item.lib].ico} /></div>
                }
            });

        };

        var renderList = this.props.adressList.map(function(item, index){

            if (item.lib.slice(0, 4) === "MET " || item.lib.slice(0, 5) === "GARE "){
                return false
            }
            else {
                return (
                    <li key={index} onClick={this.props.selectAdress.bind(null, item)} className="ligneFlexStartCentered" >

                        <div style={{width: 30, paddingRight: 5,  paddingLeft: 5,color:'gray'}}  className="fa fa-map-marker fa-lg"></div>

                        <div>
                            {item.lib}
                        </div>

                        {(item.lines && item.lines.length>0) ? renderIconeStation(item.lines) : false}

                    </li>
                );
            }



        }.bind(this));

        return (
            <div className="adressSelectionList" style={{...styles.adressSelectionList, ...this.props.topPosition}}>
                <ul style={styles.adressSelectionListUL}>
                    {renderList}
                </ul>
            </div>
        );
    }
});

var adressSelectionWraper = CreateReactClass({
    propTypes : {
        closeAdressSelection : PropTypes.func,
        selectAdress : PropTypes.func,
        initialAdress : PropTypes.string,
        selectOnMap : PropTypes.func,
    },
    defaultProps : {

    },
    getInitialState: function () {
        return {
            adressInput : '',
            adressList : [],
            topBlockPosition : {top : '-134px'},
            bottomBlockPosition : {top: styles.adressSelectionWraper.height},
            waitingForBan : false
        };
    },
    componentDidMount() {
        var wait = setTimeout(function(){
            this.setState({
                topBlockPosition : {top : 0},
                bottomBlockPosition : {top: 134}
            });
        }.bind(this), 50);

        if (this.props.initialAdress !== ''){
            this.handleAdressChange({target : {value : this.props.initialAdress}})
        }
    },
    componentWillUnmount() {
        // console.log("componentWillUnmount")
    },
    closeSearchAdress(){

        if (closing){
            return;
        } else {
            this.props.clickToOpenTimePicker();
            closing = true;
        }

        this.setState({
                topBlockPosition : {top : '-140px'},
                bottomBlockPosition : {top: styles.adressSelectionWraper.height}
        },
            function(){
                var wait = setTimeout(function(){
                    closing = false;
                    this.props.closeAdressSelection(false)
                }.bind(this),500)

            }.bind(this));
    },
    selectOnMap(){
        this.closeSearchAdress();
        var wait2 = setTimeout(function(){
            this.props.selectOnMap();
        }.bind(this),400)

    },
    handleAdressChange: function(e){

        this.setState({
            adressInput : e.target.value,
            waitingForBan : true
        });

        Promise.all([restService.getBanAdress(e.target.value),  restService.searchTransportStation(e.target.value)])
            .then(function(res){

                var list = res[1];
                list = list.concat (res[0]);

                this.setState({
                    adressList : list,
                    waitingForBan : false
                });
            }.bind(this))
            .catch(function(err){ });


    },
    selectAdress : function(item){
        this.closeSearchAdress(false);
        this.props.selectAdress(item);
    },
    clear : function(){
        this.setState({
            adressInput : '',
            adressList : []
        })
    },
    render: function () {
        return (
            <div className="adressSelectionWraper" style={styles.adressSelectionWraper}>
                <AdressSelectionInput topPosition={this.state.topBlockPosition} clear={this.clear} adressInput={this.state.adressInput} waitingForBan={this.state.waitingForBan}
                                      handleAdressChange={this.handleAdressChange} onClickSelectOnMap={this.selectOnMap} onClickBack={this.closeSearchAdress} />
                <AdressSelectionList topPosition={this.state.bottomBlockPosition} adressList={this.state.adressList} selectAdress={this.selectAdress} />
            </div>
        )
    }
});

module.exports = adressSelectionWraper;



// WEBPACK FOOTER //
// ./src/components/adressSelection/adress-selection.component.js